"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Route = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _List = _interopRequireDefault(require("@material-ui/core/List"));
var _Collapse = _interopRequireDefault(require("@material-ui/core/Collapse"));
var _pittaModules = require("@thingsw/pitta-modules");
var _RouteHeader = require("./RouteHeader");
var _clsx2 = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } // Mui List 기본 요소
////////////////////////////////////////////////////////////////////////////////////////
// 인터페이스
////////////////////////////////////////////////////////////////////////////////////////
// CSS 스타일
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return (0, _styles.createStyles)({
    root: {
      width: "100%",
      maxWidth: 500,
      padding: "0 0 0 0",
      backgroundColor: theme.palette.background.paper
      //backgroundColor: "rgba(0,0,0,0.1)",
    },

    list: {
      width: "100%",
      height: "100%",
      "&:hover": {
        backgroundColor: "rgba(0,0,0,0)"
      }
    },
    heading: {
      display: "flex"
    },
    content: {
      display: "flex",
      marginTop: "5px"
    },
    item: {
      padding: theme.spacing(1, 2),
      backgroundColor: "".concat(_pittaModules.LightColors.primary["6"], "5A"),
      "& > *": {
        marginBottom: theme.spacing(0.5)
      },
      "& > :last-child": {
        marginBottom: 0
      }
    },
    appItem: {
      padding: theme.spacing(0.75, 1),
      backgroundColor: _pittaModules.LightColors.primary["0"],
      "& > *": {
        marginBottom: theme.spacing(1)
      },
      "& > :last-child": {
        marginBottom: 0
      }
    }
  });
});
////////////////////////////////////////////////////////////////////////////////////////
// 실제 컴포넌트
var Route = function Route(props) {
  var classes = useStyles();
  var heading = props.heading,
    content = props.content,
    item = props.item,
    open = props.open,
    onClick = props.onClick,
    app = props.app;
  var theme = (0, _styles.useTheme)();
  return /*#__PURE__*/_react.default.createElement(_List.default, {
    component: "nav",
    className: classes.root,
    dir: theme.direction
  }, /*#__PURE__*/_react.default.createElement(_RouteHeader.RouteHeader, {
    heading: heading,
    content: content,
    open: open,
    onClick: onClick,
    app: app
  }), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
    in: open,
    timeout: "auto",
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_List.default, {
    className: (0, _clsx2.default)(classes.item, _defineProperty({}, classes.appItem, app)),
    component: "div",
    disablePadding: true
  }, item)));
};
exports.Route = Route;